import ModalFactory from '../../Modal';
import HamQuest from '../../api/HamQuestGiver';
import { QuestRoute } from '../../api/QuestRoutes';

export const releaseAllDeviceIDs = () => {
    ModalFactory.confirmAndProcess({
        confirmation: {
            type: 'warning',
            title: 'Warning',
            body: 'You are about to release the device IDs across all mobile app users, are you sure?',
            slideToAccept: true,
        },
        promise: {
            title: 'Releasing',
            body: 'Releasing all device IDs',
            callback: () => HamQuest.delete(QuestRoute.settings.deleteDeviceIDs)
        },
        confirmed: {
            title: 'Released',
            body: 'All device IDs successfully released',
        }
    })
}
